/** Each tab is its own route, `/reference-data/<tab>`, so a breadcrumb, a reload or the zone editor's return lands on it. The first is where `/reference-data` redirects. */
export const REFERENCE_DATA_TABS = ['truck-classes', 'trailer-types', 'document-types', 'job-types', 'zone-kinds', 'zones'] as const;
export type ReferenceDataTab = (typeof REFERENCE_DATA_TABS)[number];

export const REFERENCE_DATA_TAB_LABELS: Record<ReferenceDataTab, string> = {
  'truck-classes': 'Truck classes',
  'trailer-types': 'Trailer types',
  'document-types': 'Document types',
  'job-types': 'Job types',
  'zone-kinds': 'Zone kinds',
  zones: 'Zones',
};

export function referenceDataTabPath(tab: ReferenceDataTab): string {
  return `/reference-data/${tab}`;
}
